import { render } from "./faqAbout.vue?vue&type=template&id=34751082"
const script = {}

import "./faqAbout.vue?vue&type=style&index=0&id=34751082&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__